<template>
    <div id="marketing">
        <div class="page-inner-wrapper position-relative white-bg">
            <div class="position-relative page-header bg-img-atr-fix ">
                <div class="position-absolute overlay overlay-bg-lightdark">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <h1 class="white-color" v-scrollanimation>{{dataText.title}}</h1>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="col-sm-12 module-space">
                    <div class="column-inner">
                        <div class="wrapper">
                            <div class="module-text-container p-text text-center">
                                <p v-scrollanimation>{{dataText.p1}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="chess-table">
                        <div class="d-table-cell a-bg-1 bg-img-atr left" v-scrollanimation></div>
                        <div class="d-table-cell chess-table-textbox textbox-right p-text text-justify right" v-scrollanimation>
                            <p class="pre-formatted">{{dataText.t1}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 module-space">
                    <div class="column-inner">
                        <div class="wrapper">
                            <div class="module-text-container p-text text-center">
                                <p v-scrollanimation>{{dataText.p2}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="chess-table">
                        <div class="d-table-cell chess-table-textbox textbox-left p-text text-justify left" v-scrollanimation>
                            <p class="pre-formatted">{{dataText.t2}}</p>
                        </div>
                        <div class="d-table-cell a-bg-2 bg-img-atr right" v-scrollanimation></div>
                    </div>
                </div>
                <div class="col-sm-12 module-space">
                    <div class="column-inner">
                        <div class="wrapper">
                            <div class="module-text-container p-text text-center">
                                <p v-scrollanimation>{{dataText.p3}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="chess-table">
                        <div class="d-table-cell a-bg-1 bg-img-atr left" v-scrollanimation></div>
                        <div class="d-table-cell chess-table-textbox textbox-right p-text text-justify right" v-scrollanimation>
                            <p class="pre-formatted">{{dataText.t1}}</p>
                        </div>
                    </div>
                </div>
                <div class="spacer-lg"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../components/Footer'
    export default {
        name: "Marketing",
        props: {
            webData: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                dataText: this.webData.services.marketingAndWeb,
                mobaDev: false
            }
        },
        components: {
            Footer
        }
    }
</script>

<style scoped>
    #marketing .page-header {
        background-image: url("../assets/photos/h3_marketing_header_bg.jpg");
    }
    #marketing .page-header .overlay .d-flex {
        height: 100%;
    }

</style>